<template>
  <div class="GradeReport">
    <div class="select">
      <a-select class="option" placeholder="筛选年级" style="width: 120px" @change="handleChange" allowClear>
        <a-select-option v-for="item in schoolGrades" :key="item" :value="item">{{item}}</a-select-option>
      </a-select>
      <a-button class="commit" type="primary" @click="searchHandle">查询</a-button>
    </div>
    <div class="reportTable" v-if="reportInfo">
      <a-table :columns="columns" :dataSource="reportInfo" :rowKey="row => row.ID" :pagination="{ pageSize: 10 }" :locale="{emptyText: '该任务不包含年级报告'}">
        <template slot="GRADE" slot-scope="text">{{text}}</template>
        <div slot="PROGRESS" slot-scope="text, record" style="width: 365px">
          <a-progress :percent="parseFloat(record.PROGRESS) " :strokeWidth="6" />
        </div>
        <template slot="operation" slot-scope="text, record">
          <div style="color: #1890FF; cursor: pointer;" @click="getReportUrl(record)">查看报告</div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import GRADENEW from '@/util/gradeNew'
  // import GRADEYEAR from '@/util/gradeYear'
  import moment from 'moment'
  import URL from '@/store/url'
  export default {
    name: 'GradeRreport',
    data () {
      return {
        columns: [
        {
          title: '年级',
          dataIndex: 'GRADE',
          key: 'GRADE',
          scopedSlots: { customRender: 'GRADE' }
        },
        {
          title: '报告完成度',
          dataIndex: 'PROGRESS',
          key: 'PROGRESS',
          width: '70%',
          scopedSlots: { customRender: 'PROGRESS' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
        ],
        reportInfo: [],
        reportInfoAll: [],
        gradeVal: null,
        gradeList: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一年级', '初二年级', '初三年级', '高一年级', '高二年级', '高三年级', '大学一年级', '大学二年级', '大学三年级', '大学四年级']
      }
    },
    computed: {
      ...mapState([
        'gradeReport',
        'schoolGrades',
        'teacherAdmin',
        'taskReport'
      ]),
    },
    methods: {
      handleChange(value) {
        this.gradeVal = value
      },
      getReportUrl(record){
        console.log(record)
        console.log("this.taskReport.end_time",this.taskReport.end_time)
        let end_time = moment(this.taskReport.end_time).valueOf()
        console.log("end_time",end_time)
        let url = null
        if (new Date(this.taskReport.start_time) > new Date('2023-07-17')) {
          url = `${URL.TO_GRADE_REPORT_NEW}?questionnaireId=${this.taskReport.qid}&school_id=${this.teacherAdmin.school_id}&grade_id=${record.GRADE_ID}&endTime=${end_time}&school_name=${this.teacherAdmin.school_name}&cityId=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&teacherUid=${this.teacherAdmin.uid}&roleId=${JSON.parse(sessionStorage.getItem('userInfo')).role_id}&starttime=${this.taskReport.start_time}&endtime=${this.taskReport.end_time}&schoolName=${this.teacherAdmin.school_name}`
        } else {
          url = `${URL.TO_GRADE_REPORT}?dq_id=${this.taskReport.qid}&school_id=${this.teacherAdmin.school_id}&grade_id=${record.GRADE_ID}&end_time=${end_time}&school_name=${this.teacherAdmin.school_name}&cityId=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&uid=${this.teacherAdmin.uid}&roleId=${JSON.parse(sessionStorage.getItem('userInfo')).role_id}&starttime=${this.taskReport.start_time}&endtime=${this.taskReport.end_time}&schoolName=${this.teacherAdmin.school_name}`
        }
        if (record.FINISH >= 30) {
          window.open(url)
        } else {
          this.$confirm({
            title: '报告数据未满30人',
            content: '未满30人的报告数据不具有团体代表性，请谨慎参考，确定要继续查看吗？',
            okText: '继续查看',
            cancelText: '取消',
            onOk: () => {
              window.open(url)
            }
          })
        }
      },
      searchHandle(){
        console.log(123)
        console.log(this.reportInfoAll)
        console.log(this.gradeVal)
        this.reportInfo = this.reportInfoAll.filter((item) => !this.gradeVal ? true : item.GRADE === this.gradeVal)
      }
    },
   mounted () {
      if (this.gradeReport) {
        console.log(this.schoolGrades)
        this.gradeReport.map((item,index) =>{
          if (item.FINISH !== 0) { // 年级中至少有一个人完成才可以出班级报告
            console.log(item)
            let report = {
              ID: index,
              GRADE: GRADENEW(item.GRADE_ID).gradeListSimple,
              GRADE_ID: item.GRADE_ID,
              PROGRESS: parseInt((item.FINISH / item.TOTAL) * 100) == parseFloat((item.FINISH / item.TOTAL) * 100) ? (item.FINISH / item.TOTAL) * 100 : ((item.FINISH / item.TOTAL) * 100).toFixed(2),
              FINISH: item.FINISH
            }
            this.reportInfo.push(report)
            this.reportInfoAll.push(report)
          }
        })
      }
    }
  }
</script>

<style>
.GradeReport .select{
  display: flex;
  margin-left: 40px;
  padding: 24px 0px;
}
.GradeReport .select .ant-btn-primary{
  width:64px;
  height:32px;
  background: rgba(81,191,148,1);
  border-radius: 4px;
  border-color: rgba(81,191,148,1);
}
.GradeReport .select .option{
  width: 120px;
  margin-right: 16px;
}
.GradeReport .select > input{
  width: 180px;
  height: 32px;
  margin-right: 14px;
}
.GradeReport .select .ant-btn > span {
  color: #ffffff;
}
.GradeReport .ant-table-thead > tr > th, .GradeReport .ant-table-tbody > tr > td {
  padding: 16px 40px!important;
}
</style>